import React from 'react';

export const EbayUrl = ({item: {ebay}}) => {
    if (ebay) {
        return <>{'    '}<a href={ebay.url} target="_blank" rel="noopener noreferrer">View Item on eBay</a></>
    } else {
        return null
    }
};